import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";

type IProps = Immutable<{
    isMultiReview?: boolean;
    brand?: string;
}>;

export const WriteReviewFormDescriptionCopy = ({
    isMultiReview,
    brand,
}: IProps): React.JSX.Element => {
    return (
        <div className="wrf-rating__description-copy">
            {interpolate(
                t`Your opinion is important to us and helps other shoppers make the best choice for their needs. Thank you for sharing your %s experience.`,
                [brand || "Tempur-Pedic"],
            )}
            {isMultiReview && (
                <p>
                    {t`Uncheck any products you don't wish to review at this time.`}
                </p>
            )}
        </div>
    );
};
